import axios, { AxiosHeaders } from 'axios';
import { IHTTPGetBlobProps, IHTTPGetProps, IHTTPPostProps, IHttpPutFilesProps, IHTTPPutProps } from "./http.interfaces";
import { IKeyValue } from '../../interfaces';
import { CommonService } from '../CommonService';


interface HttpResponse<T> extends Response {
  content?: T;
}

interface HttpAxiosResponse<T> extends Response {
  data: IJSONInServerResult<T>;
}

interface IJSONInServerResult<T> {
  success: boolean;
  message: string | null;
  content: T;
}


/** HTTPService */
export class HTTPService {

  //#region XML
  public static async HttpGetXMLRequest(url: string): Promise<HttpResponse<ArrayBuffer>> {
    let response: HttpResponse<ArrayBuffer> = await fetch(url);

    try {
      response.content = await response.arrayBuffer();
    } catch (ex) {
      //console.log(ex);
    }

    //if (!response.ok) { throw new Error(response.statusText); }
    return response;
  }
  //#endregion


  //#region blob
  public static async HttpPutFiles<T>(props: IHttpPutFilesProps): Promise<IJSONInServerResult<T>> {
    return new Promise<IJSONInServerResult<T>>(async (resolve, reject) => {
      try {
        let formData = new FormData();
        props.files.forEach(file => {
          formData.append('images', file);
        });
      
       let axiosHeaders = new AxiosHeaders();
        
        //let boundary = "*****";
        axiosHeaders.set('Accept', 'application/json');
        axiosHeaders.set('Content-Type','multipart/form-data;boundary=*****"');
        let url = this.addParametersToUrl(props.urlParams, props.url)
      
        props.headerItems?.map((headerItem, idx) => {
          if (headerItem.value != null) axiosHeaders.set(headerItem.key,headerItem.value);
        })

        let response: HttpAxiosResponse<T> = await axios.put(url,formData,{
          headers: axiosHeaders,
          withCredentials: true, // Include cookies
        });


        if (!response.data.success) { return reject(response.data.message) }

        return resolve(response.data);
 
       
      }catch(e) {
        return reject(e);
      }
    });
  }

  public static async HttpGetBlobRequest(props: IHTTPGetBlobProps): Promise<HttpResponse<Blob>> {
    return new Promise<HttpResponse<Blob>>(async (resolve, reject) => {
      try {
      
        let headers = new Headers();
        props.headerItems?.map((headerItem, idx) => {
          if (headerItem.value != null) headers.append(headerItem.key,headerItem.value);
        })

        let response: HttpResponse<Blob> = await fetch(props.url, {
          method: 'GET',
          headers: headers,
          //security
          credentials: 'include',
          //redirect: 'manual'
          //mode: "no-cors",
        });

        response.content = await response.blob();
        if (!response.ok) { reject(response.statusText); }

        return resolve(response);
      }catch(e) {
        return reject(e);
      }
    });
  }
  //#endregion


  //#region JSON
  public static async HttpPutJSON<R, T>(props: IHTTPPutProps<R> ): Promise<HttpResponse<IJSONInServerResult<T>>> {
    return new Promise<HttpResponse<IJSONInServerResult<T>>>(async (resolve, reject) => {
      try {
        let headers = new Headers();
      
        //headers
        headers.append('Accept', 'application/json');
        headers.append('Content-Type', 'application/json');

        //add additional headers
        props.headerItems?.map((headerItem, idx) => {
          if (headerItem.value != null) headers.append(headerItem.key,headerItem.value);
        })

     
        let response: HttpResponse<IJSONInServerResult<T>> = await fetch(props.url, {
          headers: headers,
          method: 'PUT', body: JSON.stringify(props.contentToSend),
          credentials: 'include',
          //mode: "no-cors",
        });

        response.content = await response.json();
        if (!response.ok) { return reject(response.content?.message) }
        return resolve(response);

      }catch(e) {
        return reject(e)
      }
    });
  }

  //IJSONInServerResultNoContent
  public static async HttpPostJSON<IN, OUT>( props: IHTTPPostProps<IN> ): Promise<HttpResponse<IJSONInServerResult<OUT>>> {

    return new Promise<HttpResponse<IJSONInServerResult<OUT>>>(async(resolve, reject) => {
      try {
        let headers = new Headers();
      
        //headers
        headers.append('Accept', 'application/json');
        headers.append('Content-Type', 'application/json');

        //add additional headers
        props.headerItems?.map((headerItem, idx) => {
          if (headerItem.value != null) headers.append(headerItem.key,headerItem.value);
        })

        let response: HttpResponse<IJSONInServerResult<OUT>> = await fetch(props.url, {
          headers: headers,
          method: 'POST', body: JSON.stringify(props.contentToSend),
          //security
          
          //credentials: "include",
          credentials: 'include',
          //mode:"cors"
          //redirect: 'manual'
          //mode: "no-cors",
        });
      
      
        response.content = await response.json();
        if (!response.ok) { return reject(response.content?.message) }

        return resolve(response);

      } catch (e) {
        return reject(e?.toString())
      }
    });
  }

  public static async HttpGetJSON<T>(props: IHTTPGetProps ): Promise<HttpResponse<IJSONInServerResult<T>>> { 
    return new Promise<HttpResponse<IJSONInServerResult<T>>>(async (resolve, reject) => {
      try {
        let headers = new Headers();
        headers.append('Accept', 'application/json');

        props.headerItems?.map((headerItem, idx) => { if (headerItem.value != null) headers.append(headerItem.key,headerItem.value); })

        let response: HttpResponse<IJSONInServerResult<T>> = await fetch(props.url, { 
          headers: headers, 
          method: 'GET',
          credentials: 'include',
          //mode: "no-cors",
        });
    
        response.content = await response.json();
        if(!response.ok) { return reject(response.content?.message); }

        return resolve(response);
      }catch(e) {
        return reject(e?.toString())
      }
    });
  }
  //#endregion


  //#region unassgined
  public static async HttpGetJSONNoWrapper<T>(props: IHTTPGetProps ): Promise<HttpResponse<T>> { 
    return new Promise<HttpResponse<T>>(async (resolve, reject) => {
      try {
        let headers = new Headers();
        headers.append('Accept', 'application/json');

        props.headerItems?.map((headerItem, idx) => { if (headerItem.value != null) headers.append(headerItem.key,headerItem.value); })

        let response: HttpResponse<T> = await fetch(props.url, { 
          headers: headers, 
          method: 'GET',
          credentials: 'include',
          //mode: "no-cors",
        });
    
        response.content = await response.json();
        if(!response.ok) { return reject(response.status); }

        return resolve(response);
      }catch(e) {
        return reject(e?.toString())
      }
    });
  }
  //#endregion


  //#region unassigned
  //{sectionParentUUID}?title=""&documentParentUUID=""
  public static addParametersToUrl(params: IKeyValue<string | null>[] | Nude, url: string): string {
    if(params == null) return url;
    if(params == undefined) return url;
    if(params.length == 0) return url

    var urlIn = new URL(url);
    params.filter(CommonService.notNuDe).map((it) => { if(it.value != null) urlIn.searchParams.set(it.key, it.value) })
    return urlIn.toString()
  }
  //#endregion
}

//HTTPService.Test();
export default HTTPService;



